module.exports = __webpack_public_path__ + "static/media/Mt3logo.744a337c.png";